import React from 'react';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

export default function ContactPage() {
  return (
    <div className="container" style={{ maxWidth: '600px', margin: '40px auto', padding: '20px' }}>
      <h1 style={{ marginBottom: '30px', color: 'var(--primary)', textAlign: 'center' }}>Na kontaktoni</h1>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
        
        {/* Email */}
        <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
          <FaEnvelope size={30} color="#27ae60" />
          <h3>Email</h3>
          <p>
            <a href="mailto:orendiononline@gmail.com" style={{ color: '#27ae60', textDecoration: 'none' }}>
              orendiononline@gmail.com
            </a>
          </p>
        </div>

        {/* Adresa - Telefoni u hoq! */}
        <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
          <FaMapMarkerAlt size={30} color="#27ae60" />
          <h3>Adresa</h3>
          <p>Prishtinë, Kosovë</p>
        </div>
      </div>
    </div>
  );
}